module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-2-a6fe2d26cd6bd2aca43bb7ed1f37b153.jpg";